import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/PaymentMethod/Views/payment-method.html";
import { hotelService } from "@/Pages/Admin/Modules/Hotel/Services/HotelService";
import { hotelApi } from "@/Pages/Admin/Modules/Hotel/Services/HotelApi";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { PaymentMethodModel } from "@/Pages/Admin/Modules/Models/PaymentMethodModel";
import { HotelPaymentMethodModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelPaymentMethodModel";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";

@WithRender
@Component({
  components: {
    "validation-error": ValidationError,
  },
})
export default class PaymentMethod extends Vue {
  protected ui: any = {};
  protected item: any = {};
  protected vars: any = {};

  constructor() {
    super();
    this.ui = {
      index: {
        selected: -1,
      },
      status: {
        isLoading: {
          getHotelPaymentList: false,
          getPaymentList: false,
        },
        postLoading: {
          setHotelPaymentMethod: false,
          deleteHotelPaymentMethod: false,
        },
        fileupload: false,
      },
      error: {
        errors: {},
        has_error: false,
        error_message: {},
      },
      paging: {
        current_page: 1,
        last_page: 0,
        per_page: 0,
      },
    };

    this.item = {
      hotelPaymentMethodList: new HotelPaymentMethodModel({}),
      selectedHotelPaymentMethod: new HotelPaymentMethodModel({}),
      paymentMethodList: new PaymentMethodModel({}),
      selectPayment: new HotelPaymentMethodModel({}),
    };
  }

  public mounted() {
    this.getAllHotelPaymentMethodList();
    this.getAllPaymetMethodList();
  }

  public async getAllHotelPaymentMethodList() {
    this.ui.status.isLoading.getHotelPaymentList = true;
    let data = {
      hotel_id: this.$route.query.id,
    };
    hotelService
      .hotelPaymentList(data)
      .then((res: any) => {
        this.item.hotelPaymentMethodList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.has_error = true;
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.getImageList = false;
      });
  }

  public getAllPaymetMethodList() {
    this.ui.status.isLoading.paymentMethodList = true;
    let data = {
      current_page: this.ui.paging.current_page,
    };
    trekService
      .getPaymentMethodList(data)
      .then((res: any) => {
        var secondArray = this.item.hotelPaymentMethodList;
        var firstArray = res.data.data.data;
        let result: any = [];
        console.log(firstArray);
        console.log(secondArray);

       
        firstArray.forEach((arr1:any) => {
          secondArray.map((arr2:any) => {
            if (arr1.id === arr2.payment_method_id) {
              result.push({
                id: arr1.id,
                matche: true,
              });
            }
          });
        });

        console.log(result);
        //     console.log(this.item.hotelPaymentMethodList);
        this.item.paymentMethodList = res.data.data.data;
        this.ui.status.isLoading.getPaymentMethodList = false;
        this.ui.paging.current_page = res.data.data.current_page;
        this.ui.paging.last_page = res.data.data.last_page;
        this.ui.paging.per_page = res.data.data.per_page;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.has_error = true;
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.paymentMethodList = false;
      });
  }

  // set Banner image
  public setPaymentMethod(index: any, image: any) {
    this.resetError();
    let data = {
      hotel_id: this.$route.query.id,
      payment_method_id: image.id,
    };
    this.ui.status.postLoading.setBannerImage = true;
    hotelService
      .addPaymentMethodHotel(data)
      .then((res: any) => {
        this.getAllPaymetMethodList();
        flashService.Success("Payment Method Added", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.has_error = true;
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.setPaymentMethod = false;
      });
  }

  public hidedeleteModal() {
    this.resetError();
    $("#deleteHotelImage").modal("hide");
    $(".modal-backdrop").remove();
  }

  // Delete Image
  protected deleteModal(index: any, Image: any) {
    $("#deleteHotelImage").modal("show");
    this.item.selectedImage = Image;
    this.ui.index.selected = index;
  }

  protected deleteImage() {
    this.resetError();
    let data = {
      hotel_id: this.$route.query.id,
      id: this.item.selectedImage.id,
    };
    this.ui.status.postLoading.deleteImage = true;
    hotelService
      .deleteImage(data)
      .then((res: any) => {
        this.$delete(this.item.imageList, this.ui.index.selected);
        flashService.Success("Image Deleted", res.data.message);
        this.hidedeleteModal();
      })
      .catch((error: any) => {
        this.ui.error.has_error = true;
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.has_error = true;
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.deleteImage = false;
      });
  }

  // Image upload Section
  protected documentUploaded(data: any) {
    if (data.file_type === "image/png" || "image/jpeg" || "image/jpg") {
      this.item.imageList.unshift(data);
    }
  }

  protected onUploadHotelImage(uploadType: string) {
    this.vars.postdata.post_url = hotelApi.AddGalleryImage();
    this.vars.postdata.uploadType = uploadType;
    if (uploadType === "image") {
      this.vars.titles.btn_title = "Upload Hotel";
      this.vars.titles.browse_title = "Browse Image";
      this.vars.titles.modal_title = "Upload Image";
    }
    this.ui.status.fileupload = true;
    this.vars.postdata.hotel_id = this.$route.query.id.toString();
  }

  protected async closeUploadModal() {
    this.ui.status.fileupload = false;
  }

  public resetError() {
    this.ui.error.errors = {};
    this.ui.error.has_error = false;
    this.ui.error.error_message = {};
  }
}
